import { FormattedMessage, useIntl } from 'react-intl'
import FormatCurrency from 'components/Common/FormatCurrency'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import type { ModalFooterActionProps } from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

export interface LuxPlusOfferVoucherModalProps {
  voucherAmount: number
  primaryActionProps?: ModalFooterActionProps
}

function LuxPlusOfferVoucherModal({ voucherAmount, primaryActionProps }: LuxPlusOfferVoucherModalProps) {
  const intl = useIntl()

  return <ModalBase>
    <ModalHeader title={<FormattedMessage
      id="kOoi8fLrrLeyaNfe-cAy"
      defaultMessage="Get an extra {amount} off with {programName}"
      
      values={{ amount: <FormatCurrency format="roundedDollar" value={voucherAmount} />, programName: LUXURY_PLUS.PROGRAM_NAME }}
    />}
    />
    <ModalBody>
      <ModalContent>
        <Group direction="vertical" gap={8}>
          <BodyText variant="medium">
            <FormattedMessage
              id="4YRBsUzudn2PILRwOyVS"
              defaultMessage="Add {programName} to this booking and get an extra {amount} off this offer."
              
              values={{ amount: <FormatCurrency format="roundedDollar" value={voucherAmount} />, programName: LUXURY_PLUS.PROGRAM_NAME }}
            />
          </BodyText>
          <BodyText variant="medium">
            <FormattedMessage
              id="NMkkMaxDxfggvfJfPlgs"
              defaultMessage="At checkout, apply the {amount} voucher to redeem your discount. Voucher can only be used once."
              
              values={{ amount: <FormatCurrency format="roundedDollar" value={voucherAmount} /> }}
            />
          </BodyText>
        </Group>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={primaryActionProps}
      secondaryActionProps={{
        children: intl.formatMessage({
          id: 'JZ8nx0aIPtfB2U9UvNrf',
          defaultMessage: 'Learn about {programName}',
        }, { programName: LUXURY_PLUS.PROGRAM_NAME }),
        to: `/${LUXURY_PLUS_PATHS.LANDING_PAGE}`,
      }}
    />
  </ModalBase>
}

export default LuxPlusOfferVoucherModal
